import React from "react";
import "./Header.css";
import Button from "../Button/Button";
import { AI_CHAT_CONFIG_ADMIN ,AI_CHAT_CONFIG_USER} from "../../../../Config/AIChatConfig";

export default function Header({ onClose,roleId }) {
  return (
    <div className="header">
      <div>
        <p className="header__title">{roleId > 3 ? AI_CHAT_CONFIG_USER.title:AI_CHAT_CONFIG_ADMIN.title}</p>
        <p className="header__excerpt">{roleId > 3 ? AI_CHAT_CONFIG_USER.excerpt:AI_CHAT_CONFIG_ADMIN.excerpt}</p>
      </div>
      <div className="h-[40px]">
        <Button
          onClick={onClose}
          appearence="transparent"
          className="flex items-center justify-center"
        >
          <span className="icon icon-cancel"></span>
        </Button>
      </div>
    </div>
  );
}
